import { AuthV2Facade, SquareConnectSSOFacade, SquareSSOFacade } from '@goparrot/dashboard-gateway-sdk';
import { AccountFacade } from '@goparrot/users-v2-sdk';
import { getInterceptors, getConfig } from '@goparrot-dashboard-api/shared';

export const authFacade = new AuthV2Facade(getConfig(), getInterceptors());
export const squareSsoFacade = new SquareSSOFacade(getConfig(), getInterceptors());
export const squareConnectSsoFacade = new SquareConnectSSOFacade(getConfig(), getInterceptors());
export const accountFacade = new AccountFacade(getConfig('api/v2/users-v2'), getInterceptors());
